<template>
  <!-- name: '可捐衣物匹配' -->
  <div class="matchingWrap">
    <div class="titleBox">
      <div class="infoClass">
        <h4>匹配结果</h4>
        <span
          >根据您的标签信息<br />
          宝贝爱蓝天为您匹配到以下需求：</span
        >
      </div>
      <img src="https://img.bbalt.cn/imgh5/userCenter/img_butterfly_matching.png" alt="" />
    </div>
    <div class="listBox">
      <ul>
        <li v-for="(item, index) in dataList" :key="index">
           <h5>
            <input
              type="checkbox"
              class="checkboxClass"
              :checked="item.isCheck"
              @click="checkClick(index)"
            />
            <span>{{ item.theme }}</span
            ><img
              src="https://img.bbalt.cn/imgh5/donate/icon_narrow_right.svg"
              alt=""
            />
          </h5>
          <table v-if="donateType == 1">
            <tr v-for="(subItem, subIndex) in item.details" :key="subIndex">
              <td>
                <input
                  type="checkbox"
                  class="checkboxClass"
                  :checked="subItem.isCheck"
                  @click="checkClothesClick(index, subIndex)"
                />
              </td>
              <td>{{ subItem.sizeHeightName }}</td>
              <td>{{ subItem.sexName }}</td>
              <td>{{ subItem.seasonName }}</td>
              <td class="countBox">
                <img
                  :src="`https://img.bbalt.cn/imgh5/donate/icon_minus${
                    subItem.donateCount === 0 ? '' : '_act'
                  }.svg`"
                  alt=""
                  @click="
                    () => {
                      subItem.matchCount--;
                      handleCount(
                        index,
                        subIndex,
                        subItem.matchCount,
                        subItem.insufficiency
                      );
                      updateLocalStorage();
                    }
                  "
                />
                <input
                  type="tel"
                  class="numberboxClass"
                  v-model="subItem.matchCount"
                  @mousedown="
                    matchCount = subItem.matchCount;
                    updateLocalStorage();
                  "
                  :disabled="subItem.insufficiency === 0"
                  @change="
                    handleCount(
                      index,
                      subIndex,
                      subItem.matchCount,
                      subItem.insufficiency
                    )
                  "
                />
                <img
                  :src="`https://img.bbalt.cn/imgh5/donate/icon_add${
                    subItem.insufficiency === 0 ? '' : '_act'
                  }.svg`"
                  alt=""
                  @click="
                    subItem.matchCount++;
                    updateLocalStorage();
                    handleCount(
                      index,
                      subIndex,
                      subItem.matchCount,
                      subItem.insufficiency
                    );
                  "
                  :disabled="subItem.insufficiency === 0"
                  :class="subItem.insufficiency === 0 ? 'img-onlyRead' : ''"
                />
              </td>
              <td>
                <img
                  src="https://img.bbalt.cn/imgh5/userCenter/icon_delete.svg"
                  alt=""
                  class="deleteClass"
                  @click="
                    handleDelete(index, subIndex);
                    updateLocalStorage();
                  "
                />
              </td>
            </tr>
          </table>
          <table v-else>
            <tr v-for="(subItem, subIndex) in item.details" :key="subIndex">
              <td>
                <input
                  type="checkbox"
                  class="checkboxClass"
                  :checked="subItem.isCheck"
                  @click="checkClothesClick(index, subIndex)"
                />
              </td>
              <td>{{ subItem.categoryName }}</td>
              <td>{{ subItem.goodsName }}</td>
              <td class="countBox">
                <img
                  :src="`https://img.bbalt.cn/imgh5/donate/icon_minus${
                    subItem.donateCount === 0 ? '' : '_act'
                  }.svg`"
                  alt=""
                  @click="
                    () => {
                      subItem.matchCount--;
                      handleCount(
                        index,
                        subIndex,
                        subItem.matchCount,
                        subItem.insufficiency
                      );
                      updateLocalStorage();
                    }
                  "
                />
                <input
                  type="tel"
                  class="numberboxClass"
                  v-model="subItem.matchCount"
                  @mousedown="
                    matchCount = subItem.matchCount;
                    updateLocalStorage();
                  "
                  :disabled="subItem.insufficiency === 0"
                  @change="
                    handleCount(
                      index,
                      subIndex,
                      subItem.matchCount,
                      subItem.insufficiency
                    )
                  "
                />
                <img
                  :src="`https://img.bbalt.cn/imgh5/donate/icon_add${
                    subItem.insufficiency === 0 ? '' : '_act'
                  }.svg`"
                  alt=""
                  @click="
                    subItem.matchCount++;
                    updateLocalStorage();
                    handleCount(
                      index,
                      subIndex,
                      subItem.matchCount,
                      subItem.insufficiency
                    );
                  "
                  :disabled="subItem.insufficiency === 0"
                  :class="subItem.insufficiency === 0 ? 'img-onlyRead' : ''"
                />
              </td>
              <td>
                <img
                  src="https://img.bbalt.cn/imgh5/userCenter/icon_delete.svg"
                  alt=""
                  class="deleteClass"
                  @click="
                    handleDelete(index, subIndex);
                    updateLocalStorage();
                  "
                />
              </td>
            </tr>
          </table>
        </li>
      </ul>
    </div>
    <div v-if="failList && failList.length > 0" class="failBox">
      <span>匹配失败：</span>
      <table v-if="donateType == 1">
        <tr v-for="(item, index) in failList" :key="index">
          <td>{{ item.sizeHeightName }}</td>
          <td>{{ item.sexName }}</td>
          <td>{{ item.seasonName }}</td>
          <td>{{ item.categoryName }}</td>
        </tr>
      </table>
      <table v-if="donateType == 2">
        <tr v-for="(item, index) in failList" :key="index">
          <td>{{ item.categoryName }}</td>
          <td>{{ item.goodsName }}</td>
        </tr>
      </table>
    </div>
    <div class="footBox">
      <div :class="isBeiLan ? 'btnListBox beilanClass' : 'btnListBox'">
        <span
          ><input
            type="checkbox"
            id="allCheck"
            :checked="isAllCheck"
            @click="setAllCheck"
          /><label for="allCheck">全选</label></span
        >
      </div>
      <button class="buttonClass" @click="handleSubmit">确认捐赠</button>
    </div>
  </div>
</template>

<script>
import { fastDonate } from "@/api/donate";

export default {
  props: [ 'title'],
  components: {},
  data() {
    return {
      isBeiLan: false, //判断是贝蓝还是个人
      dataList: [],
      failList: [],
      curCount: 0,
      isAllCheck: false,
      curDataList: [],
      donateType: this.$route.query.donateType
    };
  },
  created() {
    const demands = JSON.parse(this.$route.query.data).demands
    this.dataList = demands.map((item) => {
      item.isCheck = false;
      return item;
    });
    this.failList = JSON.parse(this.$route.query.data).errors;
  },
  methods: {
    handleCount(index, subIndex, val, max) {
      if (val < 0 || !Number(val)) {
        this.dataList[index].details[subIndex].matchCount = 0;
      }
      if (Number(val) > Number(max)) {
        this.dataList[index].details[subIndex].matchCount = max;
      }
    },
    checkClick(index) {
      this.dataList[index].isCheck = !this.dataList[index].isCheck;
      this.dataList[index].isHalfCheck = !this.dataList[index].isHalfCheck;   
      this.dataList[index].details = this.dataList[index].details.map((item) => {
        item.isCheck = this.dataList[index].isCheck;
        return item;
      })
      if (this.dataList.every((item) => item.isCheck === true)) {
        this.isAllCheck = true;
      } else {
        this.isAllCheck = false;
      }
    },
    checkClothesClick(index, subIndex) {
      this.dataList[index].details[subIndex].isCheck =
        !this.dataList[index].details[subIndex].isCheck;
      if (
        this.dataList[index].details.every((item) => item.isCheck === true)
      ) {
        this.dataList[index].isCheck = true;
      } else {
        this.dataList[index].isCheck = false;
      }
      if (
        this.dataList[index].details.every((item) => item.isCheck === false)
      ) {
        this.dataList[index].isHalfCheck = false;
      } else {
        this.dataList[index].isHalfCheck = true;
      }
      if (this.dataList.every((item) => item.isCheck === true)) {
        this.isAllCheck = true;
      } else {
        this.isAllCheck = false;
      }
    },
    setAllCheck() {
      this.isAllCheck = !this.isAllCheck;
      this.dataList = this.dataList.map((item) => {
        item.isCheck = !item.isCheck;
        item.isHalfCheck = !item.isHalfCheck;
        item.details = item.details.map((subItem) => {
          subItem.isCheck = this.isAllCheck;
          return subItem;
        });
        return item;
      });
    },
    async handleSubmit() {
      let donateObj = [];
      this.curDataList = []
      this.dataList.forEach((item) => {
        if (!(item.isCheck || item.isHalfCheck)) {
          return;
        }
        const selectedDetails = item.details.filter(
          (detail) => detail.isCheck && Number(detail.matchCount) > 0
        );
        if (selectedDetails.length === 0) {
          return;
        }
        this.curDataList.push({
          id: item.id,
          type: this.donateType,
          demandCount: selectedDetails.reduce((acc, obj) => {
            return acc + Number(obj.matchCount);
          }, 0),
          details: selectedDetails.map((detail) => {
            return { id: detail.id, number: Number(detail.matchCount) };
          }),
        });
        donateObj.push({
          theme: item.theme,
          list: selectedDetails.map((e) => {
            return {
              sexName: e.sexName,
              seasonName: e.seasonName,
              donateCount: Number(e.matchCount),
              sizeHeightName: e.sizeHeightName,
              goodsName: e.goodsName,
              categoryName: e.categoryName
            };
          }),
        });
      });

      if (this.curDataList.length > 0) {
        const { code, content, message } = await fastDonate(this.curDataList);
        if (code === 200) {
          this.$toast.success("操作成功");
          this.$router.push({
            path: "/send",
            query: {
              code: content.code,
              dataList: JSON.stringify(donateObj),
              donateInfoId: content.donateInfoId,
              donateType: this.$route.query.donateType
            },
          });
        } else {
          this.$toast.fail(message);
        }
      } else {
        this.$toast.fail("请选择要捐赠数据");
      }
    },
    updateLocalStorage() {
      if (this.curSelectTab === "捐衣") {
        localStorage.setItem("donateClothes", JSON.stringify(this.clothesList));
      }
      if (this.curSelectTab === "捐物") {
        localStorage.setItem("donateGoods", JSON.stringify(this.goodsList));
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.matchingWrap {
  width: 100%;
  height: calc(100% - 100px);
  overflow: auto;
  padding-bottom: 37px;
  border-top: 1px solid #ededed;
  background-color: #fff;
  margin-top: 96px;

  .titleBox {
    width: 686px;
    height: 208px;
    background: #f5f5f5;
    border-radius: 16px;
    margin: 30px auto;
    display: flex;
    justify-content: space-between;

    .infoClass {
      display: flex;
      flex-flow: column;
      text-align: left;
      justify-content: center;
      padding-left: 40px;

      h4 {
        width: 100%;
        height: 46px;
        font-size: 36px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 46px;
        margin-bottom: 16px;
      }

      span {
        width: 390px;
        height: 68px;
        font-size: 26px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 34px;
      }
    }

    img {
      width: 210px;
      height: 210px;
      margin-right: 24px;
    }
  }

  .listBox {
    margin-top: 41px;
    width: 100%;
    margin-bottom: 72px;

    ul {
      width: 100%;
      padding: 0px 32px;

      li {
        font-weight: 400;
        color: #333333;
        height: auto;
        border-bottom: 1px solid #ededed;
        h5 {
          font-size: 30px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 40px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 40px;
          span {
            display: inline-block;
            width: 85%;
            text-align: left;
            margin-left: 32px;
          }
          img {
            height: 30px;
            width: 30px;
          }
        }
         table {
          width: 100%;
          overflow: auto;
          height: 480px;
          display: inline-block;
          tr {
            height: 120px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            font-size: 26px;
            font-weight: 400;
            color: #333333;
            line-height: 34px;

            td {
              min-width: 100px;
              text-align: left;
              &:first-child,
              &:last-child {
                min-width: auto;
              }
            }
            .deleteClass {
              width: 30px;
              height: 30px;
            }
          }
        }
      }
    }
  }

  .failBox {
    margin-bottom: 146px;
    width: 100%;
    font-size: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 40px;

    table {
      display: block;
      width: 100%;

      tr {
        width: 686px;
        height: 104px;
        border-bottom: 1px solid #ededed;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0px auto;

        td {
          padding: 0px 32px;
          text-align: left;
          width: 25%;
        }
      }
    }
  }

  .addInfoClass {
    width: 320px;
    height: 72px;
    background: #ffffff;
    border-radius: 48px;
    border: 2px solid #dddddd;
    font-size: 30px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #679fd2;
    text-align: left;
    padding-left: 128px;
    background-image: url("https://img.bbalt.cn/imgh5/userCenter/icon_addInfo.svg");
    background-size: 40px 40px;
    background-repeat: no-repeat;
    background-position: 72px 16px;
    margin-bottom: 101px;
  }

  .footBox {
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 220px;
    background: #ffffff;
    box-shadow: 0px -1px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0px 0px 16px 16px;
    display: flex;
    justify-content: space-between;

    .buttonClass {
      width: 304px;
      height: 88px;
      background: #fe66a6;
      box-shadow: 0px -1px 16px 0px rgba(0, 0, 0, 0.08);
      border-radius: 47px;
      border: none;
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 88px;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
      margin-top: 16px;
      margin-right: 32px;
    }

    .btnListBox {
      display: flex;
      font-size: 28px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
      margin-left: 64px;
      height: 80px;
      margin-top: 16px;

      input {
        margin-right: 24px;
      }

      span {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &.beilanClass {
        margin-left: 22px;

        color: #666666;
        font-size: 24px;

        input {
          margin-right: 0px;
          margin-bottom: 8px;
        }

        span {
          flex-flow: column;
          width: 96px;
          margin-right: 12px;
        }

        img {
          margin-bottom: 8px;
          width: 40px;
          height: 40px;
        }
      }
    }
  }
   .countBox {
    width: 164px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
    }
    .numberboxClass {
      width: 56px;
      height: 36px;
      background: #f5f5f5;
      border-radius: 2px;
      border: none;
      text-align: center;

      color: #333333;
    }
  }
}
</style>
